module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"domain.actions.createActionScriptCard.title":"Create Action","domain.actions.createActionScriptCard.subtitle":"Please provide the name and script text for this action script.","domain.actions.createActionScriptCard.actionName":"Script Name"}}')
  delete Component.options._Ctor
}
